import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container pt-5 text-start" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "pb-3" }, "Informasjon", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " Klatrekongen er en årlig konkurranse fordelt på tre serier - Sprint, Hill og Mountain. Hver serie innholder tre utvalgte Strava segmenter i sykkelparadiset Rogaland. ", -1)
const _hoisted_4 = { class: "container mt-2" }
const _hoisted_5 = { class: "row w-100 strava" }
const _hoisted_6 = { class: "col-md g-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom border-dark fw-bold" }, "Sprint", -1)
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "col-md g-0" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom border-dark fw-bold" }, "Hill", -1)
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "col-md g-0" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom border-dark fw-bold" }, " Mountain ", -1)
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "pt-4" }, " Konkurransen starter 1. februar og avsluttes 31. oktober hvert kalenderår. ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, " Ryttere blir allokert poeng basert på plasseringen man har i de ulike segmentene innenfor hver serie. Beste tid gir flest poeng. Resultatlisten innenfor hver serie rangeres etter summen av poeng tildelt den enkelte rytter fra de tre segmentene. ", -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Resultatlistene ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" oppdateres flere ganger daglig. ")
const _hoisted_19 = { class: "pt-3" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Informasjon om påmelding finner du ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("her")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" eller ved å gå til påmelding i fanen oppe til høyre. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sprint, (s) => {
            return (_openBlock(), _createElementBlock("p", {
              key: s.segmentId,
              class: "my-1"
            }, [
              _createElementVNode("a", {
                href: 
                                'https://www.strava.com/segments/' + s.segmentId
                            ,
                target: "_blank"
              }, _toDisplayString(s.segmentName), 9, _hoisted_8)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hill, (s) => {
            return (_openBlock(), _createElementBlock("p", {
              key: s.segmentId,
              class: "my-1"
            }, [
              _createElementVNode("a", {
                href: 
                                'https://www.strava.com/segments/' + s.segmentId
                            ,
                target: "_blank"
              }, _toDisplayString(s.segmentName), 9, _hoisted_11)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mountain, (s) => {
            return (_openBlock(), _createElementBlock("p", {
              key: s.segmentId,
              class: "my-1"
            }, [
              _createElementVNode("a", {
                href: 
                                'https://www.strava.com/segments/' + s.segmentId
                            ,
                target: "_blank"
              }, _toDisplayString(s.segmentName), 9, _hoisted_14)
            ]))
          }), 128))
        ])
      ])
    ]),
    _hoisted_15,
    _hoisted_16,
    _createElementVNode("p", null, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _hoisted_17
        ]),
        _: 1
      }),
      _hoisted_18
    ]),
    _createElementVNode("p", _hoisted_19, [
      _hoisted_20,
      _createVNode(_component_router_link, {
        to: "/registration",
        class: "fw-bold"
      }, {
        default: _withCtx(() => [
          _hoisted_21
        ]),
        _: 1
      }),
      _hoisted_22
    ])
  ]))
}